<script setup>
import { setMeta } from "@/utils/util";
import { ref, onMounted } from "vue";
import ExcelJS from "exceljs";
import JsonViewer from "vue-json-viewer";
import { UploadFilled } from "@element-plus/icons-vue";
onMounted(() => {
  document.title = "Excel转JSON";
  setMeta("description", "在线将Excel转换成json");
  setMeta("keywords", "excel转json,exceltojson,excel转换");
});

let file = "";
const jsonShowData = ref("");

const handleFileUpload = (uploadFile, uploadFiles) => {
  console.log(uploadFile);
  file = uploadFile.raw;
  convertToJSON();
};
const convertToJSON = () => {
  const fileReader = new FileReader();
  fileReader.onload = (event) => {
    const data = new Uint8Array(event.target.result);
    const workbook = new ExcelJS.Workbook();
    workbook.xlsx.load(data).then(() => {
      const jsonData = {};
      workbook.eachSheet((worksheet, sheetId) => {
        const sheetData = [];
        const headers = [];
        worksheet.getRow(1).eachCell((cell) => {
          headers.push(cell.value);
        });
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            // 跳过标题行
            const rowData = {};
            row.eachCell((cell, colNumber) => {
              const header = headers[colNumber - 1] || `column${colNumber}`;
              rowData[header] = cell.value;
            });
            sheetData.push(rowData);
          }
        });
        jsonData[worksheet.name] = sheetData;
      });
      console.log(jsonData); // 在控制台打印转换后的JSON数据
      jsonShowData.value = jsonData;
    });
  };
  fileReader.readAsArrayBuffer(file);
};
</script>

<template>
  <div class="tool-body">
    <h1 style="margin-bottom: 20px">Excel转JSON</h1>
    <div>
      <el-upload
        class="drop-upload"
        drag
        action=""
        :auto-upload="false"
        accept=".xlsx, .xls"
        :on-change="handleFileUpload"
      >
        <div class="el-upload__text">
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="">拖动文件到这里或者 <em>点击上传</em></div>
        </div>

        <template #tip>
          <div class="el-upload__tip">
            接受Excel格式文件，文档内容不符合JSON规则的话，结果可能解析失败或错乱
          </div>
        </template>
      </el-upload>
    </div>
    <JsonViewer
      style="margin-top: 10px"
      :value="jsonShowData"
      boxed
      :preview-mode="true"
      :expanded="true"
      :copyable="{ copyText: '复制结果', copiedText: '复制成功！' }"
    >
    </JsonViewer>
  </div>
</template>
<style lang="scss" scoped>
.btn-area {
  margin-top: 18px;
  margin-bottom: 10px;
  display: flex;
}
.upload {
  margin-left: 12px;
}
.el-upload__text {
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
